// extracted by mini-css-extract-plugin
export var phoneNumberInput = "_f8-0";